import { Box } from '@percent/lemonade'
import classes from './HeroImage.module.scss'

export function HeroImage({ image }: Readonly<{ image?: string | null }>) {
  return !image ? (
    <Box className={classes.BannerFallback} data-testid="description-fallback-banner-img" />
  ) : (
    <img className={classes.Banner} data-testid="description-banner-img" src={image} alt="banner-img" />
  )
}
